import { createGtm } from '@gtm-support/vue-gtm';
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import { createApp } from 'vue';

import App from './App.vue';
import './assets/css/tailwind.css';
import useApi from './composables/useApi';
import reveal from './directives/reveal';
import router from './router';

// Lara's default primary is emerald; 500 = blue-light, 600 = cobalt
const BrandPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#eef2fe',
      100: '#d9e1fc',
      200: '#b3c3fa',
      300: '#8ca5f7',
      400: '#5878f2',
      500: '#2450ed',
      600: '#1d40be',
      700: '#18339a',
      800: '#132877',
      900: '#0e1d55',
      950: '#091337',
    },
  },
});

const initializeApp = async () => {
  const unversionedApi = useApi({ useVersion: false });
  await unversionedApi.get('/sanctum/csrf-cookie');

  const app = createApp(App);

  app.use(router);
  app.directive('reveal', reveal);
  app.use(PrimeVue, {
    theme: {
      preset: BrandPreset,
      options: {
        darkModeSelector: false || 'none',
      },
    },
  });
  app.use(ToastService);

  app.use(
    createGtm({
      id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID,
      enabled: true,
      debug: false,
      loadScript: true,
      vueRouter: router,
    })
  );

  app.mount('#app');
};

initializeApp();
